import React, { useEffect, useState } from 'react';
import { Button, Form, FormGroup } from 'reactstrap';
import { aws } from '../../config';
import { useLocation, useNavigate } from 'react-router-dom';
import BZAPIService from '../../services/BZAPIService';
import Loader from '../common/Loader';
import { consumeRedirect } from '../../helpers/postLoginRedirect';

const LoginForm = () => {
  const location = useLocation();
  const [errorDescription, setErrorDescription] = useState('');

  let navigate = useNavigate();
  const hasToken = location.hash && location.hash.indexOf('id_token=') !== -1;
  useEffect(() => {
    async function onLoad() {
      const hashParams = new URLSearchParams(window.location.hash.substring(1)); // Remove the initial `#`
      const errorDescription = hashParams.get('error_description');
      if (errorDescription) {
        setErrorDescription(decodeURIComponent(errorDescription));
      }

      console.log('loading');
      console.log('location', location);
      // Detect if redirected from AWS Hosted login.
      if (location.hash && location.hash.indexOf('id_token=') !== -1) {
        // setIsLoading(true);
        const hash = location.hash.slice(1);
        const tokens = hash.split('&').reduce(function(res, item) {
          var parts = item.split('=');
          res[parts[0]] = parts[1];
          return res;
        }, {});
        // console.log('tokens', tokens);
        const idToken = tokens.id_token;
        BZAPIService.apiClient.setHeader('Authorization', `Bearer ${idToken}`);
        localStorage.setItem('bzAuthToken', idToken);

        // console.log('logged in', idToken);
        const redirect = consumeRedirect();
        if (redirect) {
          // href, not pathname — pathname cannot carry a query string.
          window.location.href = redirect;
        } else {
          navigate('/');
        }
      }
    }

    onLoad();
    // eslint-disable-next-line
  }, []);
  // Handler
  const handleSubmit = e => {
    e.preventDefault();
    console.log('aws.cognito.loginUrl', aws.cognito.loginUrl);
    window.location.href = aws.cognito.loginUrl;
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup>
        {!hasToken ? (
          <>
            <Button color="primary" block className="mt-3">
              Log in
            </Button>
            {errorDescription.length ? <small className="active">Error: {errorDescription}</small> : <></>}
          </>
        ) : (
          <Loader />
        )}
      </FormGroup>
    </Form>
  );
};

export default LoginForm;
